

<script>
import store from '../store/index.js';
export default {
    data() {
        return {
            citys: store.citys,
            baseUrl: 'https://x.autoimg.cn/landingpage/line/',
            citysLineMap: {
                220100 : 'line_changchun.png', //长春
                210100 : 'line_shenyang.png', // 沈阳
                130300 : 'line_qinhuangdao.png', //秦皇岛
                120100 : 'line_tianjin.png', // 天津
                140100 : 'line_taiyuan.png', //太原
                130100 : 'line_shijiazhuang.png', // 石家庄
                370100 : 'line_jinan.png', // 济南
                371100 : 'line_rizhao.png', // 日照
                610100 : 'line_xian.png', // 西安
                410100 : 'line_zhengzhou.png', //郑州
                340100 : 'line_hefei.png', // 合肥
                320100 : 'line_nanjing.png', // 南京
                511300 : 'line_nanchong.png', // 南充
                420500 : 'line_yichang.png', // 宜昌
                360100 : 'line_nanchang.png', // 南昌
                330100 : 'line_hangzhou.png',  // 杭州
                500100 : 'line_chongqin.png', // 重庆
                520300 : 'line_zunyi.png', // 遵义
                430100 : 'line_changsha.png', //   长沙
                350100 : 'line_fuzhou.png' // 福州
            },
            imgSrc: ''
        }
    },
    computed: {
        isShow() {
            const cityId = parseInt(this.cityId);
            if(this.citys.indexOf(cityId) > -1 && this.citysLineMap[cityId]) {
                this.imgSrc = this.baseUrl + this.citysLineMap[cityId];
                return true;
            } else {
                return false
            }
        },
        cityId() {
           return store.form.position.cityId;
        }
    },  
    methods: {
        
    }
}
</script>
<template>
  <div class="wrap" v-show="isShow">
      <h3 class="title">试驾路线</h3>
      <div class="main">
          <img :src="imgSrc" alt="">
      </div>
  </div>
</template>
<style lang="stylus" scoped>

    .title
        margin 0.5rem auto
        position relative
        width 6.72rem
        text-indent 2rem
        &:before
            content ''
            position absolute
            left 0.7rem
            top .23rem
            width 1.07rem
            height 1.12rem
            background url("../../assets/title_sjlx_bg.svg")
            background-size 100% 100%
        &:after
            content ''
            display inline-block
            position absolute
            left 0
            bottom -0.05rem
            width 100%
            height 0.11rem
            background url("../../assets/title_line.png") top left no-repeat
            background-size 100%
    .wrap
        margin-bottom 1rem
        .main
            // margin 0.8rem
            img 
                width 100%

</style>